import React, { useState } from 'react';
import { langCheck } from "Pub/js/utils.js";
import platform from "Pub/js/platform";
import subjectIcons from "Pub/js/subjectIcons";
import { ControlTip } from "Components/ControlTip";
// import Question from "Assets/images/menuicons/question.svg";
import Notice from "Components/Notice";
const { base } = platform;
const { NCTooltip } = base;

function LogoArea(props) {
    const { logoBox } = props;
    const [question, setQuestion] = useState('icon-shuoming1');
    /**
        * 左侧标题区
        * @param {String} name
        * @param {String} icon
        */
    const leftAreaTitle = (name, icon) => {
        return (
            <div className='title-area'>
                <div className='title-area-l'>
                    {/* <i className={`${icon} iconfont app-icon`} /> */}
                    {name}
                    <NCTooltip
                        className="app-tooltip"
                        placement='bottom'
                        overlay={langCheck('0000PUB-000428') /**多语- 若无权限看到配置的位置，请联系运维人员进行配置*/}
                        trigger='hover'
                        delayShow={500}
                        delay={1}
                    >
                        {/* <img className="question" src={Question}></img> */}
                        <i
                            className={`question iconfont ${question}`}
                            onMouseEnter={() => { setQuestion('icon-shuoming2'); }}
                            onMouseLeave={() => { setQuestion('icon-shuoming1'); }}
                        ></i>
                    </NCTooltip>
                </div>
            </div>
        );
    };
    // 更换
    const changeClick = (content, fieldid) => {
        ControlTip({
            status: "warning",
            title: langCheck("0000PUB-000429") /* 国际化处理： 更换*/,
            msg: content,
            fieldid, //自动化测试标记
            onOk: () => {
                // 复制功能
                const replaceImgUrl = document.getElementById('replaceImgUrl').innerHTML;
                const textareaUrl = document.getElementById('textareaUrl');
                textareaUrl.value = replaceImgUrl;
                textareaUrl.select();
                document.execCommand('copy');
                Notice({
                    status: "success",
                    msg: langCheck("0000PUB-000433"), /* 国际化处理： 复制成功*/
                });
            },
            okText: langCheck("0000PUB-000430"),
        });
    };

    return (<div className='logo-area'>
        {leftAreaTitle(
            langCheck("0000PUB-000604"),
            "icon-yeqianshezhi",
        ) /* 国际化处理： 全局设置*/}
        <textarea id='textareaUrl' style={{ opacity: '0', height: 0, position: 'absolute' }}></textarea>
        {
            logoBox.map(item => {
                const { picture, name, smallName, fieldid } = item;
                return <div 
                    className='logo-area-item' 
                    key={fieldid} 
                    fieldid={fieldid}
                >
                    <div className='logo-area-item-left'>
                        <img className='picture' src={picture} alt="" />
                        <div className='title-box'>
                            <h3 className='title'>{name}</h3>
                            <span className='small-title'>{smallName}</span>
                        </div>
                    </div>
                    {
                        item.customOprBtn || <p className='logo-area-item-right' onClick={changeClick.bind(this, item.content, fieldid)}>{langCheck('0000PUB-000429') /**  多语- 更换 */}</p>
                    }
                </div>;
            })
        }
    </div>
    );
}

export default LogoArea;